export function richdownContentByteSize(content) {
  return new TextEncoder().encode(content || '').length;
}

export function exceedsRichdownContentSize(content, maxByteSize) {
  return richdownContentByteSize(content) > maxByteSize;
}
